import React from 'react';
import { useTranslation } from 'react-i18next';
import { Landmark, Ribbon, Store, Palmtree } from 'lucide-react';
import PartnerCard from './PartnerCard';
import { trustedPartners } from './partenairesData';

export default function TrustedPartners() {
  const { t } = useTranslation();

  const sections = [
    { key: 'institution', filterKeys: ['institution', 'collectivite'], title: t('partners.institutionsCollectivities'), color: 'bg-fuchsia-600', hoverColor: 'fuchsia', icon: Landmark },
    { key: 'federation', filterKeys: ['federation'], title: t('partners.equestrianFederations'), color: 'bg-lime-500', hoverColor: 'lime', icon: Ribbon },
    { key: 'entreprise', filterKeys: ['entreprise'], title: t('partners.partnerCompanies'), color: 'bg-amber-500', hoverColor: 'amber', icon: Store },
    { key: 'tourisme', filterKeys: ['tourisme'], title: t('partners.tourismLeisure'), color: 'bg-indigo-500', hoverColor: 'indigo', icon: Palmtree },
  ];

  return (
    <section className="py-20 bg-gradient-to-b from-white to-zinc-50" data-testid="trusted-partners-section">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="text-center mb-16">
          <span className="inline-block px-4 py-2 bg-lime-100 text-lime-600 rounded-full text-sm font-medium uppercase tracking-widest mb-4">{t('partners.thankPartners')}</span>
          <h2 className="font-['Playfair_Display'] text-3xl md:text-4xl font-bold text-zinc-900 mb-4">{t('partners.theyTrusted')}</h2>
          <p className="text-zinc-600 max-w-2xl mx-auto">{t('partners.thankYouDesc')}</p>
        </div>

        {sections.map((section) => (
          <div key={section.key} className="mb-12">
            <h3 className="text-xl font-bold text-zinc-800 mb-6 flex items-center gap-3">
              <div className={`h-1 w-8 ${section.color} rounded`}></div>
              {section.title}
            </h3>
            <div className="grid grid-cols-2 md:grid-cols-4 lg:grid-cols-6 gap-4">
              {trustedPartners.filter(p => section.filterKeys.includes(p.category)).map((partner, index) => (
                <PartnerCard key={index} partner={partner} hoverColor={section.hoverColor} fallbackIcon={section.icon} />
              ))}
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}
